import en from './en.json';
import es from './es.json';
import de from './de.json';
import cs from './cs.json';
import ja from './ja.json';
import sk from './sk.json';
import it from './it.json';
import fr from './fr.json';
import pl from './pl.json';
import pt from './pt.json';
import ptBr from './pt-br.json';
import zhHk from './zh-hk.json';

export default {
  en,
  es,
  de,
  cs,
  ja,
  sk,
  it,
  fr,
  pl,
  pt,
  'pt-br': ptBr,
  'zh-hk': zhHk,
};
